import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';
import classNames from 'classnames';
import React from 'react';

export type ACIconProps = Omit<IconComponentProps, 'ref'> &
  React.RefAttributes<HTMLSpanElement>;

export default function ACIconWrapper({ className, ...props }: ACIconProps) {
  return <Icon className={classNames('ac-icon', className)} {...props} />;
}
